/**
 * Alternative investments — the quarterly-report upload, client side.
 *
 * Same shape as the monthly statements (pdfBatchApi.ts): an upload is created,
 * the documents go up (fast), are read one request at a time (each one a model
 * call), reviewed and confirmed, and only פרסום makes them client data.
 */
import { api } from '../../api.js';
import type {
  AltAdminOverview, AltBatchProgress, AltBatchView, AltFileEdit, AltPublishResult,
} from '@agio/core/domain';

export const altApi = {
  overview: (clientId: string) => api.get<AltAdminOverview>(`/admin/clients/${encodeURIComponent(clientId)}/alternatives`),
  create: (clientId: string) => api.post<{ batch_id: string }>('/admin/alt/batch', { clientId }),
  upload: (batchId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.upload<AltBatchProgress>(`/admin/alt/batch/${batchId}/file`, form);
  },
  extractNext: (batchId: string) => api.post<AltBatchProgress & { read: string | null }>(`/admin/alt/batch/${batchId}/extract-next`, {}),
  progress: (batchId: string) => api.get<AltBatchProgress>(`/admin/alt/batch/${batchId}/progress`),
  get: (batchId: string) => api.get<AltBatchView>(`/admin/alt/batch/${batchId}`),
  edit: (batchId: string, fileId: string, edit: AltFileEdit, confirm = false) =>
    api.patch<AltBatchView>(`/admin/alt/file/${fileId}`, { edit, confirm, batchId }),
  remove: (fileId: string) => api.del<{ ok: true }>(`/admin/alt/file/${fileId}`),
  publish: (batchId: string) => api.post<AltPublishResult>(`/admin/alt/batch/${batchId}/publish`, {}),
  discard: (batchId: string) => api.post<{ ok: true }>(`/admin/alt/batch/${batchId}/discard`, {}),
  rollback: (batchId: string) => api.post<{ restored: number; removed: number }>(`/admin/alt/batch/${batchId}/rollback`, {}),
  setActive: (investmentId: string, isActive: boolean) =>
    api.patch<{ ok: true }>(`/admin/alt/investment/${investmentId}`, { is_active: isActive }),
  document: (fileId: string) => api.blob(`/admin/alt/file/${fileId}/document`),
};
